import React, { useState, useEffect } from "react";
import MetaTags from "react-meta-tags";
import {
  Col,
  Container,
  Row,
  Card,
  CardBody,
  Form,
  Table,
  Input,
  Button,
  InputGroup,
  Label,
  CardFooter,
  ListGroup,
  ListGroupItem,
} from "reactstrap";

// Redux
import { connect, useDispatch } from "react-redux";
import { withRouter, Link } from "react-router-dom";

// Actions
import { checkList, checkFilter } from "store/payments/actions";

//Import Breadcrumb
import Breadcrumb from "components/Common/Breadcrumb";
import Pagination from "components/Common/Pagination";
import Loader from "components/Common/Loader";

const CheckList = (props) => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(checkList());
  }, []);

  const [search, setSearch] = useState("");

  const onChange = (e) => {
    setSearch(e.target.value);
  };

  const onSubmit = (e) => {
    e.preventDefault();
    dispatch(checkFilter(`?search=${search}`));
  };

  const resetSearch = () => {
    dispatch(checkFilter(`?search=`));
    setSearch("");
  };

  const params = {
    count: props.checks.count,
    next: props.checks.next,
    previous: props.checks.previous,
    results: props.checks.results,
  };

  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>Carnesvilla | Cheques </title>
        </MetaTags>
        <Container fluid>
          {/* Render Breadcrumb */}
          <Breadcrumb title={"Carnesvilla"} breadcrumbItem={"Cheques"} />
          {props.loading ? (
            <Loader />
          ) : (
            <div>
              <Card>
                <CardBody>
                  <Row>
                    <Col md={4}>
                      <Form className="search-box" onSubmit={onSubmit}>
                        <InputGroup>
                          <Input
                            type="text"
                            className="form-control"
                            name="search"
                            placeholder="Cliente..."
                            value={search}
                            onChange={onChange}
                          />
                          <i className="bx bx-search-alt search-icon" />
                          <Button color="primary" onClick={resetSearch}>
                            <span className=" bx bx-x fa-lg align-middle"></span>
                          </Button>
                        </InputGroup>
                      </Form>
                    </Col>
                  </Row>
                </CardBody>
              </Card>
              <Card>
                {params.count > 0 ? (
                  <CardBody className="ps-5 pe-5">
                    {/* <h2 className="mb-3 ps-5 font-size-20">Lista de vehículos</h2> */}
                    <div className="table-responsive">
                      <Table
                        className="table table-borderless table-striped align-middle table-centered table-nowrap mb-3"
                        style={{
                          textAlign: "center",
                        }}
                      >
                        <thead className="table-light">
                          <tr>
                            <th>#</th>
                            <th>Código Cliente</th>
                            <th>Nombre Cliente</th>
                            <th>Valor</th>
                            <th>Fecha</th>
                            <th>Estado</th>
                            <th>Acción</th>
                          </tr>
                        </thead>
                        <tbody>
                          {params.results.map((cheque, idx) => (
                            <tr key={idx}>
                              <th scope="row">{cheque.id}</th>
                              <td>{cheque.client}</td>
                              <td>{cheque.full_name}</td>
                              <td>$ {cheque.value.toLocaleString("es-CO")}</td>
                              <td>{cheque.created_date}</td>
                              <td>
                                {cheque.state === "en_canje" && (
                                  <span
                                    className={
                                      "badge rounded-pill bg-warning bg-soft text-warning"
                                    }
                                  >
                                    <b>En canje</b>
                                  </span>
                                )}
                                {cheque.state === "rechazado" && (
                                  <span
                                    className={
                                      "badge rounded-pill bg-danger bg-soft text-danger"
                                    }
                                  >
                                    <b>Rechazado</b>
                                  </span>
                                )}
                                {cheque.state === "aprobado" && (
                                  <span
                                    className={
                                      "badge rounded-pill bg-success bg-soft text-success"
                                    }
                                  >
                                    <b>Aprobado</b>
                                  </span>
                                )}
                              </td>
                              <td>
                                {cheque.state === "aprobado" ||
                                cheque.state === "rechazado" ? (
                                  <span className="bx bx-edit fa-lg align-middle"></span>
                                ) : (
                                  <Link to={`/checks/update/${cheque.id}`}>
                                    <span className="bx bx-edit fa-lg align-middle"></span>
                                  </Link>
                                )}
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </Table>
                    </div>
                    <Pagination
                      count={params.count}
                      next={params.next}
                      previous={params.previous}
                      limit={8}
                      baseUrl="checks/"
                      filterFunction={checkFilter}
                    />
                  </CardBody>
                ) : (
                  <CardBody>
                    <h4 className="card-title">No se encontraron resultados</h4>
                  </CardBody>
                )}
              </Card>
            </div>
          )}
        </Container>
      </div>
    </React.Fragment>
  );
};

const mapStateToProps = (state) => {
  const { error, loading, checks } = state.Payment;
  return { error, loading, checks };
};

export default withRouter(connect(mapStateToProps)(CheckList));
